import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

let onLoggedOut = () => {};
export const setLoggedOutHandler = (fn) => { onLoggedOut = fn; };

api.interceptors.response.use(null, async (error) => {
  const cfg = error.config;
  const url = cfg?.url || "";
  if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
    cfg._retry = true;
    try { await api.post("/auth/refresh"); return api(cfg); }
    catch { onLoggedOut(); }
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const brl = (cents) => (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const SOURCE_META = {
  panel: { label: "Painel IPTV", cls: "badge-panel" },
  ai: { label: "IA", cls: "badge-ai" },
  ai_panel: { label: "IA → Painel", cls: "badge-aipanel" },
  vendas: { label: "Vendas", cls: "badge-aipanel" },
  error: { label: "Erro", cls: "badge-error" },
  none: { label: "Sem resposta", cls: "badge-error" },
};

export const ORDER_STATUS = {
  novo_pedido: { label: "Novo pedido", cls: "badge-muted" },
  aguardando_pagamento: { label: "Aguardando pagamento", cls: "badge-error" },
  cliente_informou_pagamento: { label: "Cliente informou pagamento", cls: "badge-aipanel" },
  pagamento_confirmado: { label: "Pagamento confirmado", cls: "badge-panel" },
  aguardando_ativacao: { label: "Aguardando ativação", cls: "badge-panel" },
  assinatura_ativa: { label: "Assinatura ativa", cls: "badge-ai" },
  cancelado: { label: "Cancelado", cls: "badge-muted" },
  intervencao_manual: { label: "Intervenção manual", cls: "badge-danger" },
};

export const fmtDT = (v) => (v ? new Date(v).toLocaleString("pt-BR") : "—");
export const fmtD = (v) => (v ? new Date(v).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : "—");

export const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const MODELS = [
  { value: "openai|gpt-5.5", label: "OpenAI GPT-5.5" },
  { value: "openai|gpt-5.4-mini", label: "OpenAI GPT-5.4 Mini (rápido)" },
  { value: "anthropic|claude-sonnet-5-5", label: "Claude Sonnet 5.5" },
  { value: "gemini|gemini-3-flash-preview", label: "Gemini 3 Flash" },
];
